<template>
<div class="chapter">
<div class="inner_page">
<div id="fm5">
<p class="copya">Copyright © 1989 by Darcey Steinke</p>
<p class="copy">All rights reserved. No part of this book may be reproduced in any form or by any electronic or mechanical means, including information storage and retrieval systems, without permission in writing from the publisher, except by a reviewer, who may quote brief passages in a review. Any members of educational institutions wishing to photocopy part or all of the work for classroom use, or publishers who would like to obtain permission to include the work in an anthology, should send their inquiries to Grove/Atlantic, Inc., 841 Broadway, New York, NY 10003.</p>
<p class="copy">Originally published by Doubleday, a division of Bantam Doubleday Dell Publishing Group, Inc., 666 Fifth Avenue, New York, New York 10103</p>
<p class="copy"><em class="italic">Published simultaneously in Canada</em></p>
<p class="copy1"><em class="italic">Printed in the United States of America</em></p>
<p class="copy"><span class="small">FIRST GROVE PRESS EDITION</span></p>
<p class="copy">Excerpt from lyrics of “GOD BLESS AMERICA” by Irving Berlin on page 73:</p>
<p class="copy1">© Copyright 1938, 1939 by Irving Berlin</p>
<p class="copy1">© Copyright renewed 1965, 1966 by Irving Berlin</p>
<p class="copy1">© Copyright assigned to Mrs. Ralph J. Bunche, Joe DiMaggio, and Theodore R. Jackson as Trustees of God Bless America Fund. Reprint by permission of Irving Berlin Music Corporation.</p>
<p class="copy">Library of Congress Cataloging-in-Publication Data</p>
<p class="copy">Steinke, Darcey.</p>
<p class="copy3">Up through the water / Darcey Steinke.</p>
<p class="copy4">p. cm.</p>
<p class="copy3">ISBN 9780802193230</p>
<p class="copy3">1. Ocracoke Island (N.C.)—Fiction. 2. Young women—Fiction.</p>
<p class="copy1">I. Title.</p>
<p class="copy2">PS3569.T37924 U6 2000</p>
<p class="copy2">813’.54—dc21<span class="indtxt">00–037668</span></p>
<p class="copy">Grove Press</p>
<p class="copy1">841 Broadway</p>
<p class="copy1">New York, NY 10003</p>
<p class="copy">00 01 02 03   10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?0dd99f60